import { useAccount, useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { loginRequest, signUpRequest } from "../authConfig";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";

export function LoginPage() {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const navigate = useNavigate();

  useEffect(() => {
    if (account != null) {
      navigate("/home", { relative: "path" });
    }
  });

  return (
    <>
      <div className="triangle-image">
        <img src={import.meta.env.VITE_LOGIN_BACKGROUND_URL} alt="Background Image" />
      </div>

      <div className="w-full absolute top-0 bottom-0 left-0 right-0 m-auto flex items-center justify-center h-auto flex-col login-screen">
        <div className="bg-grey logout-img">
          {" "}
          <img src="/assets/icons/logout.svg" />
        </div>
        <div className="flex items-center">
          <Button
            className="border-0! bg-transparent! text-purple font-bold underline text-underline-offset"
            label="Sign in"
            onClick={() => {
              instance.loginRedirect(loginRequest);
            }}>
            {" "}
          </Button>
          <p className="text-purple font-bold pl-3 pr-3">OR</p>
          <Button
            className="border-0! bg-transparent! text-purple font-bold underline text-underline-offset"
            label="Create Account"
            onClick={() => {
              instance.loginRedirect(signUpRequest);
            }}>
            {" "}
          </Button>
        </div>
      </div>
    </>
  );
}
